import { render, staticRenderFns } from "./NursingCareGroupForm.vue?vue&type=template&id=0b1e7d8e&scoped=true"
import script from "./NursingCareGroupForm.vue?vue&type=script&lang=js"
export * from "./NursingCareGroupForm.vue?vue&type=script&lang=js"
import style0 from "./NursingCareGroupForm.vue?vue&type=style&index=0&id=0b1e7d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e7d8e",
  null
  
)

export default component.exports